import api from "../../services/baseapi";

export type AuditLogItem = {
  id: string;
  user_full_name: string | null;
  created_at: string;
  modified_at: string | null;
  action: string;
};

export type AuditLogsResponse = {
  total: number;
  page: number;
  page_size: number;
  items: AuditLogItem[];
};

export type GetAuditLogsParams = {
  project_id: string;
  filter?: string;
  date_created?: string;
  date_modified?: string;
  page?: number;
  page_size?: number;
};

export const getAuditLogs = async (
  params: GetAuditLogsParams,
): Promise<AuditLogsResponse> => {
  const query: Record<string, any> = {
    project_id: params.project_id,
    page: params.page ?? 1,
    page_size: params.page_size ?? 20,
  };

  if (params.filter) query.filter = params.filter;
  if (params.date_created) query.date_created = params.date_created;
  if (params.date_modified) query.date_modified = params.date_modified;

  const { data } = await api.get<AuditLogsResponse>("/audit-logs", {
    params: query,
  });
  return data;
};
